import { render, staticRenderFns } from "./KundenAuswahl.vue?vue&type=template&id=5f0e07da&"
import script from "./KundenAuswahl.vue?vue&type=script&lang=js&"
export * from "./KundenAuswahl.vue?vue&type=script&lang=js&"
import style0 from "./KundenAuswahl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports